import { API } from "../../../config";
import AxiosUtils from "../../../utils/AxiosUtils";
import Cookies from "../../../utils/Cookies";
import { serverAPIPath, mockAPIPath } from "../config/apiPath";

class PayeeInformationServices {

    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;

    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = { "access-token": new Cookies("access-token").read() };
    }

    async savePayeeInfo(payeeID?: number | null) {
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ? 
            await new AxiosUtils(mockAPIPath.PAYEE_INFORMATION, this.payload,this.headers).get() :
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.PAYEE_INFORMATION}${payeeID}`, this.payload,this.headers).put();
        let selectreason: string;
        if(response?.data?.success) {
            selectreason = response?.data?.message;
            return selectreason;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        } 
    }
}
export default PayeeInformationServices;

